"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var http_1 = require("@angular/common/http");
var upload_file_queue_component_1 = require("../upload-file-queue/upload-file-queue.component");
var AuthHeaders_1 = require("src/app/api/AuthHeaders");
var UploadFileComponent = /** @class */ (function () {
    function UploadFileComponent(HttpClient, matFileUploadQueue) {
        this.HttpClient = HttpClient;
        this.matFileUploadQueue = matFileUploadQueue;
        this.isUploading = false;
        /* Http request input bindings */
        this.httpUrl = "http://localhost:5000/File/TemporaryUpload";
        this.httpRequestHeaders = new http_1.HttpHeaders().set("Content-Type", "multipart/form-data");
        this.httpRequestParams = new http_1.HttpParams();
        this.fileAlias = "file";
        /** Output  */
        this.removeEvent = new core_1.EventEmitter();
        this.onUpload = new core_1.EventEmitter();
        this.onResponse = new core_1.EventEmitter();
        this.progressPercentage = 0;
        this.loaded = 0;
        this.total = 0;
        if (matFileUploadQueue) {
            this.httpUrl = matFileUploadQueue.httpUrl || this.httpUrl;
            this.httpRequestHeaders = matFileUploadQueue.httpRequestHeaders || this.httpRequestHeaders;
            this.httpRequestParams = matFileUploadQueue.httpRequestParams || this.httpRequestParams;
            this.fileAlias = matFileUploadQueue.fileAlias || this.fileAlias;
        }
    }
    Object.defineProperty(UploadFileComponent.prototype, "file", {
        get: function () {
            return this._file;
        },
        set: function (file) {
            this._file = file;
            this.total = this._file.size;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UploadFileComponent.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (id) {
            this._id = id;
        },
        enumerable: true,
        configurable: true
    });
    UploadFileComponent.prototype.upload = function () {
        var _this = this;
        this.isUploading = true;
        // How to set the alias?
        var formData = new FormData();
        var token = AuthHeaders_1.getAuthToken();
        formData.set(this.fileAlias, this._file, this._file.name);
        this.fileUploadSubscription = this.HttpClient.post(this.httpUrl, formData, {
            headers: {
                Authorization: "Bearer " + token
            },
            //this.httpRequestHeaders,
            observe: "events",
            params: this.httpRequestParams,
            reportProgress: true,
            responseType: "json"
        }).subscribe(function (event) {
            if (event.type === http_1.HttpEventType.UploadProgress) {
                _this.progressPercentage = Math.floor((event.loaded * 100) / event.total);
                _this.loaded = event.loaded;
                _this.total = event.total;
            }
            _this.onUpload.emit({ file: _this._file, event: event });
        }, function (error) {
            if (_this.fileUploadSubscription) {
                _this.fileUploadSubscription.unsubscribe();
            }
            _this.isUploading = false;
            _this.onUpload.emit({ file: _this._file, event: event });
        }, function () { });
    };
    UploadFileComponent.prototype.remove = function () {
        if (this.fileUploadSubscription) {
            this.fileUploadSubscription.unsubscribe();
        }
        this.removeEvent.emit(this);
    };
    UploadFileComponent.prototype.ngOnDestroy = function () { };
    return UploadFileComponent;
}());
exports.UploadFileComponent = UploadFileComponent;
